// frontend/src/routes/AmbulanceRoutes.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from '@dr.pogodin/react-helmet';
import DashboardLayout from '../components/layout/DashboardLayout';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import RoleBasedRoute from '../components/auth/RoleBasedRoute';

// Ambulance Pages 
import AmbulanceDashboard from '../pages/ambulance/AmbulanceDashboard';
import ManageRequests from '../pages/ambulance/ManageRequests';
import ManageVehicles from '../pages/ambulance/ManageVehicles';
import ManageDrivers from '../pages/ambulance/ManageDrivers';
import LiveTracking from '../pages/ambulance/LiveTracking';
import AmbulanceAnalytics from '../pages/ambulance/AmbulanceAnalytics';
import AmbulanceEarnings from '../pages/ambulance/AmbulanceEarnings';
import AmbulanceSubscription from '../pages/ambulance/AmbulanceSubscription';
import AmbulanceProfile from '../pages/ambulance/AmbulanceProfile';

const AmbulanceRoutes = () => {
  return (
    <ProtectedRoute>
      <RoleBasedRoute allowedRoles={['ambulance']}>
        <Routes>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={
              <>
                <Helmet>
                  <title>Ambulance Dashboard - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <AmbulanceDashboard />
              </>
            } />
            
            <Route path="requests" element={
              <>
                <Helmet>
                  <title>Service Requests - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageRequests />
              </>
            } />
            
            <Route path="vehicles" element={
              <>
                <Helmet>
                  <title>Manage Vehicles - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageVehicles />
              </>
            } />
            
            <Route path="drivers" element={
              <>
                <Helmet>
                  <title>Manage Drivers - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <ManageDrivers />
              </>
            } />
            
            <Route path="tracking" element={
              <>
                <Helmet>
                  <title>Live Tracking - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <LiveTracking />
              </>
            } />
            
            <Route path="analytics" element={
              <>
                <Helmet>
                  <title>Analytics - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <AmbulanceAnalytics />
              </>
            } />
            
            <Route path="earnings" element={
              <>
                <Helmet>
                  <title>Earnings Report - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <AmbulanceEarnings />
              </>
            } />
            
            <Route path="subscription" element={
              <>
                <Helmet>
                  <title>Manage Subscription - MediGo Ambulance Portal</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <AmbulanceSubscription />
              </>
            } />
            
            <Route path="profile" element={
              <>
                <Helmet>
                  <title>Ambulance Profile - MediGo</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <AmbulanceProfile />
              </>
            } />
          </Route>
        </Routes>
      </RoleBasedRoute>
    </ProtectedRoute>
  );
};

export default AmbulanceRoutes;